<video #videoPlayer autoplay muted playsinline></video>